import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { DashboardSummary } from "@/types.ts";

interface DashboardSummaryCardsProps {
  summary: DashboardSummary | null;
}

interface DashboardSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const DashboardSummaryCards = ({ summary }: DashboardSummaryCardsProps) => {
  const activeEventCount =
    (summary?.openEmergencyEventCount ?? 0) +
    (summary?.acknowledgedEmergencyEventCount ?? 0) +
    (summary?.inProgressEmergencyEventCount ?? 0);
  const todayNoResponseCount = summary?.todayNoResponseCount ?? 0;
  const todayRiskSoundCount = summary?.todayRiskSoundCount ?? 0;
  const offlineDeviceCount = summary?.offlineDeviceCount ?? 0;
  const cards: DashboardSummaryCard[] = [
    {
      title: "미처리 긴급 이벤트",
      value: `${activeEventCount}건`,
      badge: activeEventCount > 0 ? "즉시 확인" : "정상",
      description: `오늘 발생 ${summary?.todayEmergencyEventCount ?? 0}건`,
      tone: activeEventCount > 0 ? "red" : "teal",
      icon: "ri-alarm-warning-line",
    },
    {
      title: "오늘 무응답",
      value: `${todayNoResponseCount}건`,
      badge: todayNoResponseCount > 0 ? "확인 필요" : "정상",
      description: "일정 무응답 기준",
      tone: todayNoResponseCount > 0 ? "amber" : "teal",
      icon: "ri-time-line",
    },
    {
      title: "오늘 주의 소리",
      value: `${todayRiskSoundCount}건`,
      badge: todayRiskSoundCount > 0 ? "확인 필요" : "정상",
      description: "수집된 소리 분석 결과",
      tone: todayRiskSoundCount > 0 ? "amber" : "teal",
      icon: "ri-sound-module-line",
    },
    {
      title: "오프라인 기기",
      value: `${offlineDeviceCount}대`,
      badge: offlineDeviceCount > 0 ? "확인 필요" : "정상",
      description: "최근 연결 상태 기준",
      tone: offlineDeviceCount > 0 ? "blue" : "teal",
      icon: "ri-router-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
          variant="filled"
        />
      ))}
    </div>
  );
};

export default DashboardSummaryCards;
